<div class="d-flex flex-row flex-wrap justify-content-center gap-1">
	@for (item of items; track $index) {
		@if (item.colorHex != undefined) {
			<div class="d-flex flex-row flex-wrap gap-1 align-items-center legend-container">
				<div class="color-square m-0" [ngStyle]="{ 'background-color': item.colorHex }"></div>
				<div class="legend-label m-0">{{ item.label }}</div>
			</div>
		} @else if (item.iconPath != undefined) {
			<div class="d-flex flex-row flex-wrap gap-1 align-items-center legend-container">
				<div class="m-0"><img [src]="item.iconPath" /></div>
				<div class="legend-label m-0">{{ item.label }}</div>
			</div>
		}
	}
</div>
